module.exports = new Promise((resolve) => {
    const baseUrl = (window.RUNTIME && window.RUNTIME['MOBILESALESTOOL_REMOTE_URL']) || '';

    if (!baseUrl) {
      console.error('Missing mobile sales tool remote URL');
      return resolve({
        get: () => Promise.reject(new Error('Missing mobile sales tool remote URL')),
        init: () => {}
      });
    }

    const remoteUrl = (() => {
      const separator = baseUrl.includes('?') ? '&' : '?';
      return `${baseUrl}${separator}t=${Date.now()}`;
    })();

    if (window['mobileSalesToolApp']) {
      const existingContainer = window['mobileSalesToolApp'];
      return resolve({
        get: (request) => existingContainer.get(request),
        init: (arg) => {
          try {
            return existingContainer.init(arg);
          } catch (_) {}
        }
      });
    }

    const existingScript = document.querySelector('script[data-mf-remote="mobileSalesToolApp"]');
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        const container = window['mobileSalesToolApp'];
        if (!container) {
          return resolve({
            get: () => Promise.reject(new Error('mobileSalesToolApp not found')),
            init: () => {}
          });
        }

        resolve({
          get: (request) => container.get(request),
          init: (arg) => {
            try {
              return container.init(arg);
            } catch (_) {}
          }
        });
      });

      existingScript.addEventListener('error', () => {
        resolve({
          get: () => Promise.reject(new Error('Failed loading mobile sales tool remote')),
          init: () => {}
        });
      });

      return;
    }

    const el = document.createElement('script');
    el.src = remoteUrl;
    el.type = 'text/javascript';
    el.async = true;
    el.crossOrigin = 'anonymous';
    el.dataset.mfRemote = 'mobileSalesToolApp';

    el.onload = () => {
      const container = window['mobileSalesToolApp'];
      if (!container) {
        console.error('Remote container "mobileSalesToolApp" not found on window');
        return resolve({
          get: () => Promise.reject(new Error('mobileSalesToolApp not found')),
          init: () => {}
        });
      }

      resolve({
        get: (request) => container.get(request),
        init: (arg) => {
          try {
            return container.init(arg);
          } catch (_) {}
        }
      });
    };

    el.onerror = () => {
      console.error('Failed to load remoteEntry:', remoteUrl);
      el.remove();
      resolve({
        get: () => Promise.reject(new Error('Failed loading mobile sales tool remote')),
        init: () => {}
      });
    };

    document.head.appendChild(el);
  })
;